import { CheckIntegrationOvermind } from 'domain/usecases/eligibility/check-integration-overmind'
import { EligibilityRepository } from 'repository/repositories/eligibility/eligibility-repository'

export class RemoteCheckIntegrationOvermind
  implements CheckIntegrationOvermind
{
  constructor(private readonly eligibilityRepository: EligibilityRepository) {}
  check(surgical_order_id: number): Promise<CheckIntegrationOvermind.Model> {
    return this.eligibilityRepository.checkIntegrationOvermind(
      surgical_order_id
    )
  }
}
